import styled from "styled-components";
const Separator = styled("div").attrs({
  role: "separator",
  "aria-orientation": "vertical"
})(({ theme }) => ({
  alignSelf: "stretch",
  backgroundClip: "content-box",
  backgroundColor: theme.borderColor,
  boxSizing: "content-box",
  flexBasis: 1,
  flexGrow: 0,
  flexShrink: 0,
  width: 1
}));
export {
  Separator
};
